import { createTheme, styled, ThemeProvider } from '@mui/material/styles';
import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Outlet } from 'react-router-dom';
import { AuthUserContextProvider } from '../../provider/AuthUserContextProvider';
import { LocationHistoryProvider } from '../../provider/LocationHistoryProvider';
import { PageResourceContextProvider } from '../../provider/PageResourceContextProvider';
import OktaSecurityAuth from '../../authentication/OktaSecurityAuth';
import Error from '../MyM999_Error/Error';

const PageContainer = () => {
  const Wrapper = styled('div')(() => ({
    display: 'flex',
    flexFlow: 'column',
    alignItems: 'baseline',
    height: '100%',
    ' > * ': {
      width: '100%'
    },
  }));

  const mymineTheme = createTheme({
    palette: {
      background: { secondary: '#777777' },
    },
    components: {
      MuiFormHelperText: {
        styleOverrides: {
          root: {
            fontSize: '14px'
          }
        }
      }
    }
  });

  return (
    <OktaSecurityAuth>
      <LocationHistoryProvider>
        <PageResourceContextProvider>
          <AuthUserContextProvider>
            <ThemeProvider theme={mymineTheme}>
              <ErrorBoundary FallbackComponent={Error}>
                <Wrapper>
                  <Outlet />
                </Wrapper>
              </ErrorBoundary>
            </ThemeProvider>
          </AuthUserContextProvider>
        </PageResourceContextProvider>
      </LocationHistoryProvider>
    </OktaSecurityAuth>
  )
}
export default PageContainer;
